import viewFields from "../viewFields";

const convertToColumnDef = ({ field, model }) => {
  if (!viewFields[field.type]) {
    console.log(
      `No converter found for field ${field.name} type: ${field.type}, use default one.`,
    );
  }

  const converter =
    viewFields[field.type]?.converter || viewFields["default"].converter;
  return converter({ field, model });
};

export const getColumns = (model, page) => {
  const columns = model.fields.map((field) =>
    convertToColumnDef({ field, model }),
  );
  return columns;
};

const getPinnedColumns = (model) => {
  return model.fields
    .filter((field) => field.pinned)
    .reduce((acc, field) => {
      acc[field.pinned] = acc[field.pinned] || [];
      acc[field.pinned].push(field.name);
      return acc;
    }, {});
};

const getColumnVisibilityModel = (model) => {
  return model.fields.reduce((acc, field) => {
    if (field.hidden) {
      acc[field.name] = false;
    }
    return acc;
  }, {});
};

const getSortModel = (model) => {
  const sortedFields = model.fields.filter((field) => field.sorted)[0];
  if (!sortedFields) return [];

  return [{ field: sortedFields.name, sort: sortedFields.sorted }];
};

export const getInitialState = (model, page) => {
  return {
    pinnedColumns: getPinnedColumns(model),
    columns: {
      columnVisibilityModel: getColumnVisibilityModel(model),
    },
    sorting: {
      sortModel: getSortModel(model),
    },
  };
};

export default {
  getColumns,
  getInitialState,
};
